import { render, staticRenderFns } from "./cgm-week-study.vue?vue&type=template&id=6cf4fab4&scoped=true&"
import script from "./cgm-week-study.vue?vue&type=script&lang=js&"
export * from "./cgm-week-study.vue?vue&type=script&lang=js&"
import style0 from "./cgm-week-study.vue?vue&type=style&index=0&id=6cf4fab4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf4fab4",
  null
  
)

export default component.exports